import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const animationDuration = 500;
const swipeTreshold = { x: 30, y: 30 };
const $sliderEl = $('.slider');

$(function () {
    if ($sliderEl.length > 0) {
        $sliderEl.each(function () {
            slider($(this));
        });
    }
});

const slider = (sliderEl) => {
    const $prev = sliderEl.find('.slider__prev');
    const $next = sliderEl.find('.slider__next');
    const $indicatorDots = sliderEl.find('.slider__indicator-dot');

    const data = {
        item: 0,
        count: -1,
        itemWidth: -1,
        startMousePos: { x: -1, y: -1 },
        endMousePos: { x: -1, y: -1 },
        synckey: false,
        cardsperslide: false,
    };

    init(sliderEl, data);
    $window.on(
        'resize:width',
        debounce(function () {
            update(sliderEl, data);
        })
    );

    $prev.on('click', function () {
        scrollLeft(sliderEl, data);
    });
    $next.on('click', function () {
        scrollRight(sliderEl, data);
    });
    $indicatorDots.on('click', function () {
        data.item = $(this).data('item');
        scrollToItem(sliderEl, data);
    });

    sliderEl.on('touchstart', function (event) {
        onTouchStart(event, data);
    });
    sliderEl.on('touchend', function (event) {
        onTouchEnd(sliderEl, event, data);
    });

    if (data.synckey !== false) {
        $window.on('slider:sync', function (event, synckey, item) {
            if (data.synckey === synckey) {
                if (data.cardsperslide !== false) {
                    data.item = Math.round(item / data.cardsperslide - 1);
                } else {
                    data.item = item - 1;
                }

                if (data.item < 0) data.item = 0;
                if (data.item > data.count - 1) data.item = data.count - 1;

                scrollToItem(sliderEl, data, 0, data.item * data.itemWidth, false);
            }
        });
    }

    window.setInterval(function(){
        if (isScrolledLeft(data)) {
            scrollRight(sliderEl, data);
        } else {
            scrollLeft(sliderEl, data);
        }
    }, 5000);
};

function init(element, data) {
    const $card = element.find('.slider__card');
    data.itemWidth = $card.outerWidth(true);
    data.count = $card.length;

    if (element.hasClass('sync') && element.data('synckey') !== undefined) {
        data.synckey = element.data('synckey');
    }

    if (element.data('cardsperslide') !== undefined) {
        data.cardsperslide = element.data('cardsperslide');
    }

    scrollToItem(element, data, 0);
}

function update(element, data) {
    const $card = element.find('.slider__card');
    data.itemWidth = $card.outerWidth(true);

    scrollToItem(element, data, 0);
}

function indicator(element, data) {
    element.find('.slider__indicator-dot.active').removeClass('active');
    $(element.find('.slider__indicator-dot').get(data.item)).addClass('active');
}

function isScrolledLeft(data) {
    return data.item === 0;
}

function isScrolledRight(data) {
    return data.item === data.count - 1;
}

function scrollLeft(element, data) {
    if (!isScrolledLeft(data)) {
        data.item--;
        scrollToItem(element, data);
    }
}

function scrollRight(element, data) {
    if (!isScrolledRight(data)) {
        data.item++;
        scrollToItem(element, data);
    }
}

function scrollToItem(element, data, duration = animationDuration, position = data.item * data.itemWidth, triggerSync = data.synckey !== false ? true : false) {
    const $sliderContainer = element.find('.slider__container');

    $sliderContainer.stop().animate({ scrollLeft: position }, duration, function () {
        if (isScrolledLeft(data)) {
            element.addClass('slider-is-left');
        } else {
            element.removeClass('slider-is-left');
        }

        if (isScrolledRight(data)) {
            element.addClass('slider-is-right');
        } else {
            element.removeClass('slider-is-right');
        }

        indicator(element, data);

        if (triggerSync === true && element.is(':visible')) {
            let item = data.item + 1;
            if (data.cardsperslide !== false) {
                item *= data.cardsperslide;
            }
            $window.trigger('slider:sync', [data.synckey, item]);
        }
    });
}

function onTouchStart(event, data) {
    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.startMousePos.x = touch.pageX;
    data.startMousePos.y = touch.pageY;
}

function onTouchEnd(element, event, data) {
    const evt = typeof event.originalEvent === undefined ? event : event.originalEvent;
    const touch = evt.touches[0] || evt.changedTouches[0];
    data.endMousePos.x = touch.pageX;
    data.endMousePos.y = touch.pageY;

    const mousePosDiff = {
        x: data.startMousePos.x - data.endMousePos.x,
        y: data.startMousePos.y - data.endMousePos.y,
    };

    data.startMousePos = { x: -1, y: -1 };
    data.endMousePos = { x: -1, y: -1 };

    if (Math.abs(mousePosDiff.x) > swipeTreshold.x) {
        if (mousePosDiff.x > 0) {
            scrollRight(element, data);
        } else {
            scrollLeft(element, data);
        }
    }
}
